import styled from 'styled-components'

export const HiddenArea = styled.div`
  visibility: hidden;
  position: absolute;
  pointer-events: none;
  top: 0;
`
